import { ColourSwatch } from './ColourSwatch';

export const SelectedColourSwatch = ({
    id,
    currentColour,
    colours,
    setColours,
    selectedColours,
    setSelectedColours,
}) => {
    const deselectColour = () => {
        const deselectedColour = { ...currentColour, selected: false };
        const updatedColours = colours.map(colour => {
            return colour.id === currentColour.id ? deselectedColour : colour;
        });

        const updatedSelectedColours = selectedColours.filter(selectedColour => selectedColour.id !== currentColour.id)
            .map((colour, index) => ({...colour, position: index}))

        setColours(updatedColours);
        setSelectedColours(updatedSelectedColours);
    };

    return <ColourSwatch testId={`selected-colour-swatch-${id}`} id={id} colour={currentColour} size="med" onClick={deselectColour} />;
};
